// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l-Z1","toggle":"styles_toggle__OaN9o","preview":"styles_preview__3bOGZ"};